import { Directive, ElementRef, inject, OnDestroy, OnInit, Renderer2, DOCUMENT } from '@angular/core';

import {
  lockLayoutEditorScroll,
  unlockLayoutEditorScroll,
} from './dashboard-layout-editor.helpers';

/**
 * Moves the customize-layout backdrop to `document.body` so `position: fixed`
 * covers the full viewport (sidebar + navbar), and locks page scroll while attached.
 */
@Directive({
  selector: '[appLayoutEditorOverlay]',
  standalone: true,
})
export class LayoutEditorOverlayDirective implements OnInit, OnDestroy {
  private readonly doc = inject(DOCUMENT);
  private readonly renderer = inject(Renderer2);
  private readonly host = inject(ElementRef<HTMLElement>);

  private originalParent: ParentNode | null = null;
  private originalNextSibling: ChildNode | null = null;

  ngOnInit(): void {
    this.attachToBody();
    lockLayoutEditorScroll();
  }

  ngOnDestroy(): void {
    this.restoreParent();
    unlockLayoutEditorScroll();
  }

  private attachToBody(): void {
    const el = this.host.nativeElement;
    if (el.parentNode === this.doc.body) return;

    this.originalParent = el.parentNode;
    this.originalNextSibling = el.nextSibling;
    this.renderer.appendChild(this.doc.body, el);
  }

  private restoreParent(): void {
    const el = this.host.nativeElement;
    if (!this.originalParent || el.parentNode !== this.doc.body) return;

    if (this.originalNextSibling) {
      this.originalParent.insertBefore(el, this.originalNextSibling);
    } else {
      this.originalParent.appendChild(el);
    }
    this.originalParent = null;
    this.originalNextSibling = null;
  }
}
